import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { route } from '../config';
import { RettungskartenPrecache } from './rettungskarten-precache';

const RettungskarteDetails = lazy(() => import('./RettungskarteDetails'));
const RettungskartenHersteller = lazy(() => import('./RettungskartenHersteller'));
const RettungskartenListe = lazy(() => import('./RettungskartenListe'));

export default function Rettungskarten() {
  return (
    <>
      <RettungskartenPrecache />
      <Route exact path={route} component={RettungskartenListe} />
      <Route exact path={`${route}/:herstellerId/:modellId`} component={RettungskarteDetails} />
      <Route exact path={`${route}/:herstellerId`} component={RettungskartenHersteller} />
    </>
  );
}
